import { addAlert } from '../MsgNotify/msgNotifyActions';
import { httpGet, httpPost, httpPut } from '../Util/http';


export const GET_APV_REQUEST = 'GET_APV_REQUEST';
export function getApvRequest() {
    return {
        type: GET_APV_REQUEST
    }
}

export const SET_APVS = 'SET_APVS'
export function setApvs(apvs, init) {
    return {
        type: SET_APVS,
        apvs,
        init
    }
}

export const UPDATE_APV = 'UPDATE_APV'
export function update(key, value, index) {
    return {
        type: UPDATE_APV,
        key,
        value,
        index
    }
}

export const SET_APV = 'SET_APV'
export function setApv(obj, index) {
    return {
        type: SET_APV,
        obj,
        index
    }
}

export const UPDATE_APV_PDF = 'UPDATE_APV_PDF'
export function updateApv(document, index) {
    return {
        type: UPDATE_APV_PDF,
        document,
        index
    }
}

export const ADD_ROW = 'ADD_ROW'
export function addRow() {
    return {
        type: ADD_ROW,
        row: {
            name: ''
        }
    }
}

export function cancel(index) {
    return (dispatch, getState) => {
        let old = getState().apvReducer.init[index + '']
        old.changed = false
        dispatch(setApv(old, index))
    }
}

export function getApvs() {
    return dispatch => {
        const url = process.env.REACT_APP_webApiEndPoint + `api/apv`;
        dispatch(getApvRequest())
        httpGet(url)
            .then(resp => resp.json())
            .then((apvs) => {
                let o = apvs.concat([])
                dispatch(setApvs(apvs, o))
            })
            .catch(() => {
                dispatch(addAlert('Kunne ikke hente apver'))
            })
    }
}

export const SAVE_APV_SUCCESS = 'SAVE_APV_SUCCESS'
export function saveApvSuccess(index, id, document, name) {
    return {
        type: SAVE_APV_SUCCESS,
        index,
        id,
        document,
        name
    }
}

export function saveApv(index) {
    return (dispatch, getState) => {
        const url = process.env.REACT_APP_webApiEndPoint + `api/apv/save`;
        let obj = getState().apvReducer.apvs[index + '']

        if (obj.id) {
            httpPut(url, obj)
                .then(resp => resp.json())
                .then((ok) => {
                    dispatch(saveApvSuccess(index, ok.apvId, ok.document, obj.name))
                })
                .catch(() => {
                    dispatch(addAlert('Kunne ikke gemme apv'))
                })
        } else {
            httpPost(url, obj)
                .then(resp => resp.json())
                .then((ok) => {
                    dispatch(saveApvSuccess(index, ok.apvId, ok.document, obj.name))
                })
                .catch(() => {
                    dispatch(addAlert('Kunne ikke gemme apv'))
                })
        }
    }
}



// WEBPACK FOOTER //
// ./src/App/APV/actions.js